import {z as r} from 'zod';

export type DashboardLpsType = {
    startDate: string;
    endDate: string;
};

export const dashboardLpsResponseSchema = r.array(
    r.object({
        date: r.string(),
        avgLps: r.number().nullable(),
    })
);

export type DashboardLpsResponseType = r.infer<typeof dashboardLpsResponseSchema>;

export const dashboardLpsBenchmarksResponseSchema = r.object({
    avgLps: r.number().nullable(),
    maxLps: r.number().nullable(),
});

export type DashboardLpsBenchmarksResponseType = r.infer<typeof dashboardLpsBenchmarksResponseSchema>;
